// ─────────────────────────────────────────────────────────────────────────────
// SEAL DEFINITIONS  –  10 unique motivating seals (5 days × morning/afternoon)
// ─────────────────────────────────────────────────────────────────────────────

export const SEALS = [
  {
    key: 'idea_spark',
    day: 1,
    session: 'morning',
    emoji: '🌟',
    gradient: 'linear-gradient(135deg, #FF6B35, #FFD166)',
    shadow: '#FF6B3560',
    en: 'Idea Spark',
    ja: 'アイデアの種',
    descEn: 'You discovered your Big Idea!',
    descJa: 'ビッグアイデアを見つけた！',
  },
  {
    key: 'problem_hunter',
    day: 1,
    session: 'afternoon',
    emoji: '🔎',
    gradient: 'linear-gradient(135deg, #FF8C00, #FFD166)',
    shadow: '#FF8C0060',
    en: 'Problem Hunter',
    ja: '問題ハンター',
    descEn: 'You spotted a real-world problem!',
    descJa: 'リアルな問題を発見した！',
  },
  {
    key: 'customer_detective',
    day: 2,
    session: 'morning',
    emoji: '🕵️',
    gradient: 'linear-gradient(135deg, #06D6A0, #00B4D8)',
    shadow: '#06D6A060',
    en: 'Customer Detective',
    ja: 'お客様探偵',
    descEn: 'You know exactly who your customer is!',
    descJa: 'お客様のことを完璧に知った！',
  },
  {
    key: 'super_listener',
    day: 2,
    session: 'afternoon',
    emoji: '👂',
    gradient: 'linear-gradient(135deg, #00B4D8, #0077B6)',
    shadow: '#00B4D860',
    en: 'Super Listener',
    ja: 'スーパーリスナー',
    descEn: 'Your listening skills are amazing!',
    descJa: '聞く力がすごすぎる！',
  },
  {
    key: 'creative_builder',
    day: 3,
    session: 'morning',
    emoji: '🎨',
    gradient: 'linear-gradient(135deg, #A855F7, #EC4899)',
    shadow: '#A855F760',
    en: 'Creative Builder',
    ja: 'クリエイタービルダー',
    descEn: 'You built something totally awesome!',
    descJa: 'めちゃくちゃすごいものを作った！',
  },
  {
    key: 'brand_champion',
    day: 3,
    session: 'afternoon',
    emoji: '🏷️',
    gradient: 'linear-gradient(135deg, #EC4899, #F43F5E)',
    shadow: '#EC489960',
    en: 'Brand Champion',
    ja: 'ブランドチャンプ',
    descEn: 'Your brand stands out from the crowd!',
    descJa: 'あなたのブランドは最高！',
  },
  {
    key: 'money_wizard',
    day: 4,
    session: 'morning',
    emoji: '💰',
    gradient: 'linear-gradient(135deg, #F59E0B, #EF4444)',
    shadow: '#F59E0B60',
    en: 'Money Wizard',
    ja: 'マネーウィザード',
    descEn: 'You mastered the magic of money!',
    descJa: 'お金の魔法をマスターした！',
  },
  {
    key: 'market_master',
    day: 4,
    session: 'afternoon',
    emoji: '📊',
    gradient: 'linear-gradient(135deg, #EF4444, #DC2626)',
    shadow: '#EF444460',
    en: 'Market Master',
    ja: 'マーケットマスター',
    descEn: 'You understand the market like a pro!',
    descJa: 'プロのようにマーケットを理解した！',
  },
  {
    key: 'brave_speaker',
    day: 5,
    session: 'morning',
    emoji: '🎤',
    gradient: 'linear-gradient(135deg, #118AB2, #06D6A0)',
    shadow: '#118AB260',
    en: 'Brave Speaker',
    ja: 'ブレイブスピーカー',
    descEn: 'You spoke with amazing courage!',
    descJa: '勇気を持って発表した！',
  },
  {
    key: 'future_entrepreneur',
    day: 5,
    session: 'afternoon',
    emoji: '🚀',
    gradient: 'linear-gradient(135deg, #FF6B35, #A855F7)',
    shadow: '#FF6B3560',
    en: 'Future Entrepreneur',
    ja: '未来のアントレプレナー',
    descEn: 'You are a TRUE entrepreneur!',
    descJa: 'あなたは本物のアントレプレナーだ！',
  },
];

// ─────────────────────────────────────────────────────────────────────────────
// DAILY ROUTINE ACTIVITIES  –  given every day regardless of program
// ─────────────────────────────────────────────────────────────────────────────
export const DAILY_ROUTINE_ACTIVITIES = [
  { key: 'cleaning',   session: 'cleaning',   emoji: '🧹', en: 'Cleaning',       ja: '清掃',       time: '9:30–10:00',    descEn: 'Kept the space clean and tidy!',       descJa: '教室をきれいに片付けた！' },
  { key: 'warmup',     session: 'warmup',     emoji: '🤸', en: 'Warm-up',        ja: 'ウォームアップ', time: '10:00–10:30', descEn: 'Warmed up body and mind!',             descJa: '体と心の準備バッチリ！' },
  { key: 'brush',      session: 'brush',      emoji: '🦷', en: 'Brush & Clean',  ja: '歯磨き清掃',  time: '13:30–13:45',   descEn: 'Brushed teeth and tidied up after lunch!', descJa: '昼食後の歯磨き・片付け完了！' },
  { key: 'boardgames', session: 'boardgames', emoji: '🎲', en: 'Board Games',    ja: 'ボードゲーム', time: '16:00–17:30', descEn: 'Played with great sportsmanship!',      descJa: '素晴らしいスポーツマンシップで遊んだ！' },
];

// Helper: get seal by day + session
export const getSeal = (day, session) =>
  SEALS.find(s => s.day === day && s.session === session);

// Day accent colors
export const DAY_ACCENT = {
  1: '#FF6B35',
  2: '#06D6A0',
  3: '#A855F7',
  4: '#F59E0B',
  5: '#118AB2',
};

// Day themes per program — used by StampGrid and SealPassport
export const PROGRAM_DAY_THEMES = {
  'kids-entrepreneurship': {
    en: ['The Big Idea', 'Know Your Customer', 'Build It & Brand It', 'Money & Market', 'Pitch Day! 🎤'],
    ja: ['ビッグアイデア', 'お客様を知ろう', '作って・ブランドに', 'お金とマーケット', 'ピッチ発表！🎤'],
    accent: { 1: '#FF6B35', 2: '#06D6A0', 3: '#A855F7', 4: '#F59E0B', 5: '#118AB2' },
  },
  'ai-literacy': {
    en: ['What Is AI?', 'How AI Learns', 'AI Gets It Wrong', 'AI in My World', 'Graduation Day! 🎓'],
    ja: ['AIとは何か？', 'AIの学び方', 'AIの間違い', '生活の中のAI', '卒業の日！🎓'],
    accent: { 1: '#118AB2', 2: '#06D6A0', 3: '#EF4444', 4: '#A855F7', 5: '#F59E0B' },
  },
  'public-presentation': {
    en: ['Speaking with Confidence', 'Sharing Stories', 'Expressing Ideas', 'Working Together', 'Finding Your Voice! 🎤'],
    ja: ['自信を持って話そう', '物語を語ろう', 'アイデアを伝えよう', 'チームで働こう', '自分の声を見つけよう！🎤'],
    accent: { 1: '#A855F7', 2: '#EC4899', 3: '#06B6D4', 4: '#10B981', 5: '#F59E0B' },
  },
  'esports': {
    en: ['What Is Esports?', 'Communication & Teamwork', 'Strategy & Problem Solving', 'Sportsmanship & Resilience', 'Tournament Day! 🏆'],
    ja: ['eスポーツとは？', 'コミュニケーション＆チームワーク', 'ストラテジー＆問題解決', 'スポーツマンシップ＆レジリエンス', 'トーナメントの日！🏆'],
    accent: { 1: '#06B6D4', 2: '#10B981', 3: '#8B5CF6', 4: '#EF4444', 5: '#F59E0B' },
  },
};

// ── Score-based tier system ───────────────────────────────────────────────────
// Teacher slides 0–100 and student receives the matching tier seal
export const SCORE_TIERS = [
  { min: 1,  max: 10,  emoji: '🌱', gradient: 'linear-gradient(135deg, #86EFAC, #4ADE80)', shadow: '#4ADE8060', en: 'Starting Out', ja: 'スタート！' },
  { min: 11, max: 20,  emoji: '🌿', gradient: 'linear-gradient(135deg, #4ADE80, #22C55E)', shadow: '#22C55E60', en: 'Growing',       ja: '成長中！' },
  { min: 21, max: 30,  emoji: '⭐', gradient: 'linear-gradient(135deg, #FCD34D, #F59E0B)', shadow: '#F59E0B60', en: 'Rising',        ja: '上昇中！' },
  { min: 31, max: 40,  emoji: '🌟', gradient: 'linear-gradient(135deg, #F59E0B, #D97706)', shadow: '#D9770660', en: 'Shining',       ja: '輝き！' },
  { min: 41, max: 50,  emoji: '💡', gradient: 'linear-gradient(135deg, #FB923C, #F97316)', shadow: '#F9731660', en: 'Thinking',      ja: '閃いた！' },
  { min: 51, max: 60,  emoji: '🔥', gradient: 'linear-gradient(135deg, #F97316, #EF4444)', shadow: '#EF444460', en: 'On Fire!',      ja: '燃えてる！' },
  { min: 61, max: 70,  emoji: '🚀', gradient: 'linear-gradient(135deg, #06B6D4, #0891B2)', shadow: '#06B6D460', en: 'Zooming!',     ja: '急上昇！' },
  { min: 71, max: 80,  emoji: '💪', gradient: 'linear-gradient(135deg, #8B5CF6, #7C3AED)', shadow: '#8B5CF660', en: 'Strong!',      ja: '強い！' },
  { min: 81, max: 90,  emoji: '🏆', gradient: 'linear-gradient(135deg, #FF6B35, #FFD166)', shadow: '#FF6B3560', en: 'Champion!',    ja: 'チャンピオン！' },
  { min: 91, max: 100, emoji: '💎', gradient: 'linear-gradient(135deg, #A855F7, #06D6A0)', shadow: '#A855F760', en: 'Diamond!',     ja: 'ダイヤモンド！' },
];

export const getScoreTier = (score) => {
  if (!score || score <= 0) return null;
  const s = Math.max(1, Math.min(100, score));
  return SCORE_TIERS.find(t => s >= t.min && s <= t.max) || SCORE_TIERS[SCORE_TIERS.length - 1];
};

// All 6 programs (for passport)
export const ALL_PROGRAMS = [
  { key: 'kids-entrepreneurship', icon: '💡', color: 'linear-gradient(135deg, #FF6B35, #FFD166)', sessions: 10, active: true,  en: 'Kids Entrepreneurship', ja: 'キッズ・アントレプレナーシップ' },
  { key: 'ai-literacy',           icon: '🤖', color: 'linear-gradient(135deg, #06B6D4, #06D6A0)', sessions: 10, active: false, en: 'AI Literacy',           ja: 'AIリテラシー' },
  { key: 'public-presentation',   icon: '🎤', color: 'linear-gradient(135deg, #A855F7, #EC4899)', sessions: 10, active: true,  en: 'Public Presentation',   ja: 'パブリックプレゼン' },
  { key: 'esports',               icon: '🎮', color: 'linear-gradient(135deg, #06B6D4, #118AB2)', sessions: 10, active: true,  en: 'E-Sports',              ja: 'eスポーツ' },
  { key: 'vedic-mathematics',     icon: '🔢', color: 'linear-gradient(135deg, #F59E0B, #EF4444)', sessions: 10, active: false, en: 'Vedic Mathematics',     ja: 'ヴェーダ数学' },
  { key: 'robotics',              icon: '🦾', color: 'linear-gradient(135deg, #10B981, #06B6D4)', sessions: 10, active: false, en: 'Robotics',              ja: 'ロボティクス' },
  { key: 'daily-routine',         icon: '📋', color: 'linear-gradient(135deg, #64748b, #94a3b8)', sessions: 20, active: true,  en: 'Daily Routine',         ja: 'デイリールーティン' },
];
